// extracted by mini-css-extract-plugin
export default {"syncIcon":"returnButton_syncIcon__O8wsW","syncButton":"returnButton_syncButton__MtkZd","syncButtonText":"returnButton_syncButtonText__R0keh"};